// Components
import TextComponent from '@/components/text/component'
import ImageTextComponent from '@/components/image-text/component'

// The index page is the first page the user reaches when navigating to the site, residing under the root ("/") URL.
export default {
  name: 'privacy-policy',
  components: { TextComponent, ImageTextComponent }
}



// WEBPACK FOOTER //
// ./src/pages/about/privacy-policy/script.js